const I18NPlugin = {
    install(Vue, options) {
        Vue.mixin({
            computed: {
                i18nReady: function () {
                    return options.i18n.availableLocales.indexOf(options.i18n.fallbackLocale) >= 0;
                }
            }
        });
    }
};

export default I18NPlugin;